module.exports = __webpack_public_path__ + "dd49a44ce9f9413d4abe56dbff9b09f4.png";